import React from 'react'
import { Controller } from 'react-hook-form'
import ReactSelect, { createFilter } from 'react-select'

import { Input } from '@chakra-ui/react'
import FieldWrapper from '../FieldWrapper/FieldWrapper'

import CustomMenuList from './CustomMenuList'
import CustomOption from './CustomOption'
import { isNullish } from '@/utils/helper'

const MultiSelect = ({
  name,
  options = [],
  allOptions = [],
  disabled,
  isRequired = true,
  defaultValue = '',
  extraOnChange = () => {},
  ...rest
}) => {
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => {
        const valueAsArray = Array.isArray(value) ? value : [value].filter((val) => val !== '' && !isNullish(val))

        const currentOptionValues = options.map((opt) => opt.value)

        const hasStaleValues = valueAsArray.length > 0 && valueAsArray.some((val) => !currentOptionValues.includes(val))

        const selectedOptions = valueAsArray
          .map((val) => {
            const selectedOption =
              options.find((opt) => opt.value === val) || allOptions.find((opt) => opt.value === val)
            return selectedOption
          })
          .filter((opt) => !isNullish(opt))

        const displayText = selectedOptions
          .map((opt) => opt?.label || '')
          .filter((text) => text !== '')
          .join(', ')

        return (
          <FieldWrapper name={name} error={error} tooltip={displayText} isRequired={isRequired} {...rest}>
            {disabled && <Input w="100%" value={displayText} disabled />}

            {!disabled && (
              <ReactSelect
                ref={ref}
                isMulti={true}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                  container: () => ({
                    flex: 1,
                  }),
                  control: (base, { isDisabled }) => {
                    let bgColor = 'white'
                    if (value === '' && isRequired) {
                      bgColor = 'yellow'
                    }

                    if (isDisabled) {
                      bgColor = 'hsl(0, 0%, 95%)'
                    }
                    return {
                      ...base,
                      backgroundColor: bgColor,
                      borderColor: hasStaleValues ? 'orange' : '#E2E8F0',
                    }
                  },
                  singleValue: (base) => ({
                    ...base,
                    color: 'hsl(0, 0%, 50%)',
                  }),
                  multiValueRemove: (base, state) => {
                    return state.isDisabled ? { ...base, display: 'none' } : base
                  },
                }}
                filterOption={createFilter({ ignoreAccents: false })}
                options={options}
                value={selectedOptions}
                onChange={(selectedOptions) => {
                  if (disabled) {
                    return
                  }

                  if (!selectedOptions || selectedOptions === null) {
                    onChange('')
                    extraOnChange('')

                    return
                  } else {
                    onChange(selectedOptions.map((v) => v.value))
                    extraOnChange(selectedOptions.map((v) => v.value))

                    return
                  }
                }}
                onFocus={() => {
                  const errorElement = document.getElementById(name)
                  if (errorElement) {
                    errorElement.scrollIntoView({
                      behavior: `smooth`,
                      block: 'center',
                    })
                  }
                }}
                onBlur={onBlur}
                components={{
                  Option: CustomOption,
                  MenuList: CustomMenuList,
                }}
                isDisabled={disabled}
                isClearable={!disabled}
                menuPortalTarget={document.body}
              />
            )}
          </FieldWrapper>
        )
      }}
    />
  )
}

export default MultiSelect
